import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    excludingVAT: 'excl. VAT.',
  },
  fr: {
    excludingVAT: 'HT',
  },
} as const);
